import React from "react";
import { useSelector } from "react-redux";
import { getLocale } from "../../../../utils/helperFunctions";
import useTheme from "../../../../hooks/useTheme";
import { AppPrimaryButton, PrimaryChip } from "../../../UI/CustomButtons";
import { AppColumn, AppRow, Wrap } from "../../../UI/Layouts";
import { SizedBox } from "../../../UI/Sizes";
import AppText from "../../../UI/Texts/AppTexts";
import UserActions from "../../../../utils/Constants/UserActions";
import { t } from "i18next";
import { Icon } from "semantic-ui-react";
import { useResponsive } from "../../../UI/ResponsiveContext";

const EmploymentTypeSelectionSection = ({ formData, updateFormData, onNext }) => {
  const { isMobile } = useResponsive()
  const theme = useTheme();

  const core = useSelector((state) => state.core);
  const coreConstants = Object.freeze(core.constants);

  const employmentTypes = coreConstants.employmentTypes ?? [];

  const employmentOptions = employmentTypes.map((e) => {
    return {
      key: e.id,
      text: e.text[getLocale()],
      value: e.id,
    }
  })


  const handleEmploymentTypeClick = (type) => {
    if (!formData.employmentTypes.includes(type)) {
      updateFormData("employmentTypes", [...formData.employmentTypes, type]);
    } else {
      updateFormData("employmentTypes", [...formData.employmentTypes.filter((e) => e !== type)]);
    }
  };

  return (

    <AppColumn>
      <AppRow mainAxisAlignment={'space-between'} crossAxisAlignment={'center'}>
        <AppText.HeadingBig className={'text-headline'} fontWeight={600}>
          {t('registration.select_employment_type.title')}
        </AppText.HeadingBig >
        <AppPrimaryButton
          userActionKey={UserActions.select_employment_type}
          size={'large'}
          onClick={onNext} style={{
            borderRadius: theme.radius.small,
          }}>
          {t('next')}
        </AppPrimaryButton>
      </AppRow>
      <SizedBox height={theme.spacing.contentPadding} />


      <AppRow crossAxisAlignment={'center'}>
        <Icon name="suitcase" color={theme.primaryColor} style={{
          color: theme.primaryColor,
          paddingBottom: '20px',
        }} />
        <AppText.Footnote>
          {t('registration.select_employment_type.description')}
        </AppText.Footnote>
      </AppRow>
      <SizedBox height={theme.spacing.elementPadding} />
      <Wrap>

        {employmentOptions.map((emType) => {
          const selected = formData.employmentTypes.includes(emType.value);

          return (
            <PrimaryChip
              icon={selected && 'check'}
              selected={selected}
              small={isMobile}
              secondary={true}
              text={emType.text}
              onClick={() => handleEmploymentTypeClick(emType.value)} />
          );
        })}
      </Wrap>
    </AppColumn>

  );
};

export default EmploymentTypeSelectionSection;